import { render, staticRenderFns } from "./header-status-card.vue?vue&type=template&id=0fa303d2&scoped=true"
import script from "./header-status-card.vue?vue&type=script&lang=js"
export * from "./header-status-card.vue?vue&type=script&lang=js"
import style0 from "./header-status-card.vue?vue&type=style&index=0&id=0fa303d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa303d2",
  null
  
)

export default component.exports